import { chargingPointStatusUtils } from '@/utils/chargingPointStatus'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import ChargingSessionBody from '../components/ChargingSessionBody'

const OccupiedChargingPointScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Este carregador está <b style={{ color: chargingPointStatusUtils.getColorValue('OCCUPIED') }}>ocupado</b>{' '}
              no momento.
              <br />
              Por favor, utilize um carregador disponível.
            </>
          }
        />
      }
    />
  )
}

export default OccupiedChargingPointScreen
